import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
  useLocation,
} from 'react-router-dom';
import About from './components/About/About';
import ContactUs from './components/ContactUs/ContactUs';
import Donate from './components/Donate/Donate';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/Home';
import Ministries from './components/Ministries';
import MinistryDetails from './components/MinistryDetails';
import Services from './components/Services';
import Events from './components/Events/Events';
import Members from './components/Members/Members';
import Forms from './components/Forms/Forms';
import { getAnalytics, logEvent } from 'firebase/analytics';
import './firebase';
import FormDetails from './components/Forms/FormDetails';
import CompletedForm from './components/Forms/CompletedForm';
import Admin from './components/Admin/Admin';
import Media from './components/Admin/Media';
import BackgroundLetter from './components/Forms/BackgroundLetter';
import BudgetPlanningLetter from './components/Forms/BudgetPlanningLetter';
import SundayAnnouncements from './components/SundayAnnouncements';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import MarriageMinistry from './components/MarriageMinistry';
import MarriageLessons from './components/MarriageLessons';
import LessonDetail from './components/LessonDetail';
// import CalendarPage from './components/Events/CalendarPage';
import SummerCruise from './components/SummerCruise/SummerCruise';
import SubmittedBreastCancer2 from './components/Admin/SubmittedBreastCancer2';
import SubmittedFormTable from './components/Admin/SubmittedFormTable';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import PollVote from './components/PollVote';
import ChildCheckIn from './components/ChildCheckIn';
import FamilyManagement from './components/ChildCheckIn/FamilyManagement';
import ChildForm from './components/ChildCheckIn/ChildForm';
import CheckInAdmin from './components/ChildCheckIn/CheckInAdmin';
import CheckInHistory from './components/ChildCheckIn/CheckInHistory';
import PrintQueueLoadTest from './components/ChildCheckIn/PrintQueueLoadTest';
import PrintQueueMonitor from './components/ChildCheckIn/PrintQueueMonitor';
import { AuthProvider } from './context/AuthContext';
import VBS2026 from './components/Forms/VBS2026';
import Orders from './components/Orders/Orders';
// import ChildCheckIn from './components/ChildCheckIn/ChildCheckIn';
// import { ChildForm, ManualCheckIn } from './components/ChildCheckIn';

const analytics = getAnalytics();

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// const Marriage = () => {
//   useEffect(() => {
//     window.location.href = 'https://forms.gle/du7CtAEdqhsZGyqz6';
//   }, []);
//   return null;
// };

const AvRequests = () => {
  useEffect(() => {
    window.location.href =
      'https://docs.google.com/forms/d/e/1FAIpQLSf8DYFUCMMT_-lA44TBNwYP7WIKqSkHv2Y6JX70wN0aa5jHtg/viewform?embedded=true';
  }, []);
  return null;
};

function TrackPageView() {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_path: location.pathname,
    });
  }, [location]);

  return null;
}

const App: React.FC = () => {
  const router = createBrowserRouter([
    {
      element: (
        <>
          <Header />
          <TrackPageView />

          <ScrollToTop />
          <Outlet />
        </>
      ),
      children: [
        {
          path: '/',
          element: <Home />,
        },
        {
          path: '/services',
          element: <Services />,
        },
        {
          path: '/ministries',
          element: <Ministries />,
        },
        {
          path: '/ministries/:id',
          element: <MinistryDetails />,
        },
        {
          path: '/ministries/vDWXSpEKCNq1UwJluojE',
          element: <Navigate to="/marriage" replace />,
        },
        {
          path: 'about/:page?',
          element: <About />,
        },
        {
          path: 'contact-us',
          element: <ContactUs />,
        },
        {
          path: 'donate',
          element: <Donate />,
        },
        {
          path: 'give',
          element: <Donate />,
        },
        {
          path: 'order',
          element: <Orders />,
        },
        {
          path: 'events/:id?',
          element: <Events />,
        },
        {
          path: 'members/:page?',
          element: <Members />,
        },
        {
          path: 'forms',
          element: <Forms />,
        },
        {
          path: 'forms/:id?',
          element: <FormDetails />,
        },
        {
          path: 'forms/:id/completed',
          element: <CompletedForm />,
        },
        {
          path: 'forms/:id/submitted',
          element: <SubmittedFormTable />,
        },
        {
          path: 'admin/:page?',
          element: <Admin />,
        },
        {
          path: 'admin/submitted-forms/:id',
          element: <SubmittedFormTable />,
        },
        {
          path: 'volunteer-application-procedure',
          element: <BackgroundLetter />,
        },
        {
          path: 'background-checks',
          element: <BackgroundLetter />,
        },
        {
          path: 'budget-planning-letter',
          element: <BudgetPlanningLetter />,
        },
        {
          path: 'sunday-announcements',
          element: <SundayAnnouncements />,
        },
        {
          path: 'marriage',
          element: <MarriageMinistry />,
        },
        {
          path: 'marriage/lessons',
          element: <MarriageLessons />,
        },
        {
          path: 'marriage/lessons/:id',
          element: <LessonDetail />,
        },
        {
          path: '/ministries/marriage',
          element: <MarriageMinistry />,
        },
        // {
        //   path: '/calendar',
        //   element: <CalendarPage />,
        // },
        {
          path: '/cruise2026',
          element: <SummerCruise />,
        },
        {
          path: '/youth-vbs-2026',
          element: <VBS2026 />,
        },
        {
          path: '/admin/breast-cancer-seminar-2025',
          element: <SubmittedBreastCancer2 />,
        },
        {
          path: '/checkin',
          element: <ChildCheckIn />,
        },
        {
          path: '/checkin/family',
          element: <FamilyManagement />,
        },
        {
          path: '/checkin/family/add',
          element: <ChildForm />,
        },
        {
          path: '/checkin/family/:childId',
          element: <ChildForm />,
        },

        {
          path: '/checkin/history',
          element: <CheckInHistory />,
        },
        // {
        //   path: '/checkin/add',
        //   element: <ChildForm />,
        // },
        // {
        //   path: '/checkin/edit/:id',
        //   element: <ChildForm />,
        // },
        // {
        //   path: '/checkin/walkin',
        //   element: <ManualCheckIn />,
        // },
        {
          path: 'av-requests',
          element: <AvRequests />,
        },
        {
          path: 'terms-of-service',
          element: <TermsOfService />,
        },
        {
          path: 'privacy-policy',
          element: <PrivacyPolicy />,
        },
        {
          path: 'poll/:id',
          element: <PollVote />,
        },
      ],
    },
    {
      path: '/checkin/admin',
      element: <CheckInAdmin />,
    },
    {
      path: '/checkin/load-test',
      element: <PrintQueueLoadTest />,
    },
    {
      path: '/checkin/print-monitor',
      element: <PrintQueueMonitor />,
    },
    {
      path: '/checkin/kiosk',
      element: <ChildCheckIn />,
    },
    {
      children: [
        {
          path: 'm/:media',
          element: <Media />,
        },
      ],
    },
  ]);

  // const router = createBrowserRouter([
  //   {
  //     path: '/',
  //     element: <Home />,
  //   },
  //   {
  //     path: '/services',
  //     element: <Services />,
  //   },
  //   {
  //     path: '/ministries',
  //     element: <Ministries />,
  //   },
  //   {
  //     path: '/ministries/:id',
  //     element: <MinistryDetails />,
  //   },
  //   {
  //     path: 'about',
  //     element: <About />,
  //   },
  //   {
  //     path: 'contact-us',
  //     element: <ContactUs />,
  //   },
  //   {
  //     path: 'donate',
  //     element: <Donate />,
  //   },
  // ]);
  const isMedia = window.location.pathname.startsWith('/m/');
  return (
    <HelmetProvider>
      <div style={{ flex: 1 }}>
        <div style={{ flex: 1 }}>
          {/* <Header /> */}
          <AuthProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <RouterProvider router={router} />
            </LocalizationProvider>
          </AuthProvider>
        </div>
        {!isMedia && <Footer />}
      </div>
    </HelmetProvider>
  );
};

export default App;
